import styled from 'styled-components';
import noDataImage from 'assets/images/no-data.png';
import { ApButtonMain } from '@alixpartners/ui-components';

export const Container = styled.div`
  height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 400px;
  height: 400px;
  background-image: url(${noDataImage});
  background-size: 400px;
  margin-bottom: -40px;
`;

export const UploadButton = styled(ApButtonMain)`
  margin-top: 48px;
`;
